import React from 'react'; 
import './Pillars.css';

import { Heading } from '../../../components';
import { pillars } from '../../../constants';

   
 
const Pillars = () => {    
  return (
    <section className='pillars linear-bg'>

      <Heading title={'Pillars of Islam'} subTitle={'Core Beliefs'} linear />

      {/* Container for all pillar items */}
      <div className='box-container'>
      { 
      // Looping through pillars data and rendering each item
        pillars.map((pillar) => {
          return <div className='pillar-item' key={pillar.id}>
            <div className='icon'>{pillar.icon}</div> {/* Icon of the pillar */}
            <h4>{pillar.title}</h4> {/* Title of the pillar */}
            <p>{pillar.content}</p> {/* Description of the pillar */}
          </div>
        })
      }
      </div>

    </section>
  )
}

export default Pillars;